// removed by extract-text-webpack-plugin
module.exports = {"richEditor":"g42RfwVHlanTFcoo8AAig"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/RichEditor/RichEditor.scss
// module id = 931
// module chunks = 0